import React, { useEffect, useState } from 'react';
import styles from './OptionsSelector.module.scss';
import SvgWithBranding from 'component/hoc/branding/withBrandingColor.hoc';
import OptionsSelectorModal from './options-selector-modal/OptionsSelectorModal';
import { useBrandingContext } from 'app-context/BrandingsContext';
import Label from '../label/Label';

const OptionsSelector = ({
  label,
  placeholder,
  name,
  value = [],
  onChange,
  onBlur,
  error,
  touched,
  maxOptions,
  ...props
}) => {
  const { brandingData } = useBrandingContext();
  const { page_TextColor } = brandingData;
  const [showModal, setShowModal] = useState(false);
  const [options, setOptions] = useState([]);
  const [errorMessage, setErrorMessage] = useState(null);

  useEffect(() => {
    if (value && Array.isArray(value)) {
      setOptions(value);
    }
  }, [value]);
  const handleAddOption = (newValue) => {
    if (newValue && !options.some((opt) => opt.optionValue === newValue)) {
      if (!maxOptions || options.length < maxOptions) {
        const updatedValues = [...options, { optionValue: newValue }];
        setOptions(updatedValues);
        if (onChange) {
          onChange({
            target: {
              name,
              value: updatedValues,
            },
          });
        }
      } else {
        setErrorMessage(`You can't add more than ${maxOptions} options`);
      }
    }
  };

  const handleRemoveOption = (optionToRemove) => {
    const updatedValues = options.filter(
      (opt) => opt.optionValue !== optionToRemove
    );
    setOptions(updatedValues);
    if (onChange) {
      onChange({
        target: {
          name,
          value: updatedValues,
        },
      });
    }
  };

  return (
    <>
      <div className={styles['input-container']}>
        {label && <Label text={label} htmlFor="select" />}
        <div
          className={`${styles['input-wrapper']} ${
            error && touched ? styles['error'] : ''
          }`}
          onClick={() => setShowModal((prev) => !prev)}
        >
          <div className={styles['img-input-cont']}>
            <div className={styles['joined-options']}>
              {options.length > 0 ? (
                options.map((opt) => opt.optionValue).join(', ')
              ) : (
                <p>Manage Option</p>
              )}
            </div>
          </div>
          <SvgWithBranding type="plusSVG" color={page_TextColor} />
        </div>
      </div>
      <OptionsSelectorModal
        options={options}
        showModal={showModal}
        onClose={() => setShowModal(false)}
        page_TextColor={page_TextColor}
        handleAddOption={handleAddOption}
        handleRemoveOption={handleRemoveOption}
        maxOptions={maxOptions}
        errorMessage={errorMessage}
        setErrorMessage={setErrorMessage}
      />
    </>
  );
};

export default OptionsSelector;
